import { createUseStyles } from 'react-jss';
import { boxShadows, colors } from '@insurancemenu/imenu-components-lib/dist/utils';

const styles = {
  disclaimer: {
    backgroundColor: colors.neutral.white,
    boxShadow: boxShadows.dark[16],
    borderRadius: '1rem',
    padding: '2rem',
    margin: '4rem auto 0',
  },
  disclaimerTitle: {
    fontSize: '1.6rem',
    lineHeight: '2rem',
    margin: 0,
    marginBottom: '1.5rem',
  },
  disclaimerText: {
    fontSize: '1.4rem',
    lineHeight: '2rem',
    margin: 0,
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
